// @ts-strict-ignore
import type { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'

import type { Route, RouteRecord } from 'vue-router'
import type { Store } from 'vuex'

import type { FeatureIdEnum } from '../enums'
import type { GuardResolveFunction } from '../models'

import { CONTAINER } from '../config'

import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'

import { ROUTER_CONSTS } from '../router/router.consts'

import { TAGGING_CONSTS } from '../store/tagging/tagging.consts'

import { TaggingUtils } from '../utils'

export class TaggingGuard extends GuardClass {
  private static timeout: ReturnType<typeof setTimeout>

  static execute(this: void, to: Route, from: Route, next: GuardResolveFunction): void {
    const instanceId = TaggingGuard.getInstanceIdFromRoute(to)
    const domain = TaggingGuard.getDomainFromRoute(to)
    const featureId = TaggingGuard.getFeatureIdFromRoute(to)
    if (
      instanceId !== TaggingGuard.getInstanceIdFromRoute(from) ||
      domain !== TaggingGuard.getDomainFromRoute(from) ||
      featureId !== TaggingGuard.getFeatureIdFromRoute(from)
    ) {
      clearTimeout(TaggingGuard.timeout)
      if (featureId) {
        const payload = TaggingUtils.getTaggingPayload(featureId, domain)
        if (payload) {
          TaggingGuard.timeout = setTimeout(async () => {
            const store = CONTAINER.get<Store<any>>(TYPES.Store)
            await store.dispatch(
              `${TAGGING_CONSTS.moduleName}/${TAGGING_CONSTS.actions.tagView}`,
              payload,
            )
          }, 10000)
        }
      }
    }
    next()
  }

  private static getInstanceIdFromRoute(route: Route): string {
    return route.params[ROUTER_CONSTS.params.instanceId]
  }

  private static getDomainFromRoute(route: Route): DomainEnum {
    let domain: DomainEnum
    route.matched.some((matched: RouteRecord) => {
      domain = matched.meta?.domain as DomainEnum
      return !!domain
    })
    return domain
  }

  private static getFeatureIdFromRoute(route: Route): FeatureIdEnum {
    return route.meta?.featureId
  }
}
